module.exports = __webpack_public_path__ + "img/840.813fb64b.svg";